import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ScreenSizeService } from "../../../services/screen-size.service";
import { nonNegativeValidator } from '../../../shared/validators/negative-number-validator';

@Component({
  selector: 'app-rebid',
  templateUrl: './rebid.component.html',
  styleUrls: ['./rebid.component.css']
})
export class RebidComponent {
  modalForm!: FormGroup;
  isMobile: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public currentBid: string, // TODO: Change to the type required for rebid request
    private fb: FormBuilder,
    private screenSizeService: ScreenSizeService,
    public dialogRef: MatDialogRef<RebidComponent>
  ) {
    this.modalForm = this.fb.group({ bidPrice: ['', [Validators.required, Validators.min(1),  nonNegativeValidator()]]});
  }

  ngOnInit(): void {
    this.screenSizeService.isMobile$.subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  get bidPrice() {
    return this.modalForm.get("bidPrice");
  }

  submitBid(): void {
    console.log("Submitting rebid with bidPrice: ", this.bidPrice?.value, " to current bid: ", this.currentBid);
    this.dialogRef.close({ bidPrice: this.bidPrice?.value });
  }
}
